export class Questioner {
    constructor(
      public bom_id?: number,
      public productName?: string,
      public product_code?: string,
      public productDescription?: string,
      public company_id?: number,
      public questionerMapping?: QuiestionerMapping[]
    ) {
      this.bom_id = bom_id;
      this.productName = productName;
      this.product_code = product_code;
      this.productDescription = productDescription;
      this.company_id = company_id;
      this.questionerMapping = questionerMapping;
    }
  }

  interface QuiestionerMapping {
    correctAnswer?:any;
    question?:any;
    weightage?:any;
    answer?:any;
    remark?:any;
    questionType?:any;
    mandatory?:any;
    approver_id?:any;
    role_master_id?:any;
  }
  